import React, {FC, useMemo, useRef, useState} from "react";
import {LavoratorePresenzeRecord} from "@commons/mapping/LavoratorePresenzeRecord";
import {StatoWeekPLUSRecord} from "@commons/mapping/StatoWeekPLUSRecord";
import {PresenzeGiornataPlusRecord} from "@commons/mapping/PresenzeGiornataPlusRecord";
import {TurnoRecord} from "@commons/mapping/TurnoRecord";
import {RiepilogoOrePlus} from "@commons/mapping/RiepilogoOrePlus";
import {GiustificativoRecord} from "@commons/mapping/GiustificativoRecord";
import classNames from "classnames";
import styles from "../pianificazione.module.css";
import {DateTime} from "luxon";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import {Periodo} from "@commons/types";
import {range} from "lodash";
import {BadgeTurnoByDay} from "./BadgeTurno";
import {BadgeHHCCLav} from "./BadgeHHCC";
import TooltipEx from "@components/Tooltip";
import {useKeyPress} from "@hooks/useKeyPress";
import {useEventListener} from "usehooks-ts";
import {FPNetDate} from "@commons/types";
import {useAppSelector} from "@hooks/redux-hooks/hooks";
import {selectIdAzienda, selectIdAziendaMaster} from "@commons/core.slice";
import {isDateBetween} from "@commons/utils/util";
import {Utils} from "@commons/mapping/PresenzeGiornataPlusRecord.pianificazione";
import {Calc, Coppia} from "@commons/mapping/Calc";
import {TargetBox} from "./TargetBox";
import {GestionePlusData, HHWeekStatus} from "@commons/services/presenze_calcolo/GestionePlusData";
import {IconAlarm, IconCircleFilled} from "@tabler/icons-react";
import {annoMeseGiorno2DT} from "@utilities/helpers";

export const asHHCC = (x: number) => (x / 60).toFixed(2);

export function useHover2<T extends HTMLElement = HTMLElement>(
    //elementRef: RefObject<T>,
    dtGiornata?: FPNetDate,
    setValue?: React.Dispatch<React.SetStateAction<FPNetDate>>
) {
    const ref = useRef<T | null>(null);
    const handleMouseEnter = () => {
        if (setValue && dtGiornata)
            setValue(dtGiornata)
    }
    const handleMouseLeave = () => {
        if (setValue) setValue(null)
    }

    useEventListener('mouseenter', handleMouseEnter, ref)
    useEventListener('mouseleave', handleMouseLeave, ref)

    return {ref};
}

export const Week: React.FC<{
    periodo?: Periodo,
    lavoratore: LavoratorePresenzeRecord | null,
    week: StatoWeekPLUSRecord,
    index: number,
    days: PresenzeGiornataPlusRecord[],
    turni: TurnoRecord[],
    giustificativi: GiustificativoRecord[],
    showCalendario: boolean,
    showOre: boolean,
    showTurno: boolean,
    showRiepiloghi: boolean,
    onDropFiliale?: (filiale: AziendaRecord, target: PresenzeGiornataPlusRecord | PresenzeGiornataPlusRecord[]) => void,
    onDropTurno?: (turno: TurnoRecord | null, target: PresenzeGiornataPlusRecord | PresenzeGiornataPlusRecord[]) => void,
    onResetTurno?: (target: PresenzeGiornataPlusRecord | PresenzeGiornataPlusRecord[]) => void,
    onDropGiustificativo?: (giustificativo: GiustificativoRecord, target: PresenzeGiornataPlusRecord | PresenzeGiornataPlusRecord[]) => void,
    onClickGiornata?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>, target: PresenzeGiornataPlusRecord) => void,
}> = ({
          periodo,
          lavoratore,
          week,
          index,
          days,
          turni,
          giustificativi,
          showCalendario,
          showOre,
          showTurno,
          showRiepiloghi,
          onDropTurno = (turno: TurnoRecord | null, target: PresenzeGiornataPlusRecord | PresenzeGiornataPlusRecord[]) => {
          },
          onResetTurno = (target: PresenzeGiornataPlusRecord | PresenzeGiornataPlusRecord[]) => {
          },
          onDropGiustificativo = (giustificativo: GiustificativoRecord, target: PresenzeGiornataPlusRecord | PresenzeGiornataPlusRecord[]) => {
          },
          onDropFiliale = (filiale: AziendaRecord, target: PresenzeGiornataPlusRecord | PresenzeGiornataPlusRecord[]) => {
          },
          onClickGiornata = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, target: PresenzeGiornataPlusRecord) => {
          },
      }
) => {
    const elencoFestivita: DateTime[] = useMemo(() => annoMeseGiorno2DT(require('../../../../data/festivita.json')), []);
    const idAziendaMaster = useAppSelector(selectIdAziendaMaster);
    const idAzienda = useAppSelector(selectIdAzienda);
    const [currentDtGiornata, setCurrentDtGiornata] = useState<FPNetDate>(null)
    const hasMancante = (totali: RiepilogoOrePlus | null) => {
        return totali ? RiepilogoOrePlus.hasMancante(totali) : false;
    }
    const hasEccedente = (totali: RiepilogoOrePlus | null) => {
        return totali ? RiepilogoOrePlus.hasEccedente(totali) : false;
    }
    const formatLavorato = (totali: RiepilogoOrePlus | null) => {
        if (totali) {
            const lavorato = RiepilogoOrePlus.getTotaleHLav(totali);
            return lavorato ? asHHCC(lavorato) : RiepilogoOrePlus.hasMancante(totali) ? '' : '-';
        } else
            return '-';
    }
    const hhWeeks = lavoratore ? GestionePlusData.getMinMaxHContr(lavoratore, lavoratore, week) : {} as HHWeekStatus;
    const getLabelBaseHH = function (week: StatoWeekPLUSRecord, weekIndex: number): string {
        if (lavoratore && lavoratore.days) {
            //const hhWeeks = GestionePlus.getMinMaxHContr(lavoratore, lavoratore, week);
            if (hhWeeks.hhMin === hhWeeks.hhMax) {
                if (hhWeeks.hhMin !== hhWeeks.totOrdPrevisteTurno)
                    return asHHCC(hhWeeks.totOrdPrevisteTurno) + ` [µ${asHHCC(hhWeeks.hhMin)}]`;
                else
                    return asHHCC(hhWeeks.hhMin);
            } else {
                if (hhWeeks.hhInizio < hhWeeks.hhFine)
                    return `da ${asHHCC(hhWeeks.hhInizio)} a ${asHHCC(hhWeeks.hhFine)}, per ${asHHCC(hhWeeks.totOrdPrevisteTurno)} sviluppate`;
                else return '';
            }
        } else
            return '??,??';
    };

    {/*border-collapse border border-slate-400*/
    }

    // https://eliaslog.pw/how-to-add-multiple-refs-to-one-useref-hook/
    //const [ref, hovering] = useHover();
    const isCtrlPressed = useKeyPress(null, true);

    if (hhWeeks.forzabile){
        console.log(styles.alertForzabile2)
    }
    const alertAlto = hhWeeks.sviluppoAlto ? `${hhWeeks.forzabile ? styles.alertForzabile2 : 'bg-anomalia'} text-slate-100` : '';
    const alertBasso = hhWeeks.sviluppoBasso ? `${hhWeeks.forzabile ? styles.alertForzabile2 : 'bg-anomalia'} text-slate-100` : '';
    const targetWeek = setupTargetWeek(lavoratore, [days[0], days[1], days[2], days[3], days[4], days[5], days[6]]);
    //const spacing = !showRiepiloghi ? 'border-separate border-spacing-y-10' : ''
    const alertUp = !showRiepiloghi ? (hhWeeks.sviluppoAlto ? 'border-t-2 border-red-500 mt-[2px]' : 'mt-[4px]') : '';
    const alertDwn = !showRiepiloghi ? (hhWeeks.sviluppoBasso ? 'border-b-2 border-red-500 mb-[2px]' : 'mb-[4px]') : '';
    const xSetteGiorni = range(0, 7);
    const getStyle = (value: number) => [value < 5 && styles.altriGiorni, value === 5 && styles.sabato, value === 6 && styles.domenica];

    // filiale distaccante (la filiale che "cede" il lavoratore)
    // filiale distaccataria (la filiale che riceve il lavoratore)
    const isInFiliale = (day: PresenzeGiornataPlusRecord): boolean => {
        if (!day)
            return false;
        return idAzienda === idAziendaMaster // Se sto operando sulla master => TUTTI!
            || idAzienda === day.idAzienda // Se il lavoratore appartiene alla filiale
            ;
    }
    const isInFilialeXPianificazione = (day: PresenzeGiornataPlusRecord): boolean => {
        if (!day)
            return false;
        return idAzienda === idAziendaMaster || ((day.vociPianificazione && day.vociPianificazione.length > 0)
            && (day.vociPianificazione.find(v => v.idAzienda === idAzienda) ? true : false)); // Il lavoratore NON appartiene alla filiale ma vi è un evento c/o tale filiale
    }
    const isOutFiliale = (day: PresenzeGiornataPlusRecord): boolean => {
        if (!day)
            return false;
        if (idAzienda === idAziendaMaster) // Se sto operando sulla master => Considero tutte le pianificazioni su filiali diverse da quelle del lavoratore!
            return ((day.vociPianificazione && day.vociPianificazione.length > 0)
            && (day.vociPianificazione.find(v => v.idAzienda !== day.idAzienda)) ? true : false);
        else // Se opero su una singola filiale => considero le pianificazioni su filiali diverse da quella in esame
            return ((day.vociPianificazione && day.vociPianificazione.length > 0)
            && (day.vociPianificazione.find(v => v.idAzienda !== idAzienda)) ? true : false);
    }

    const getHHPianificate = (day: PresenzeGiornataPlusRecord) => {
        const result = Utils.getPrevistoPianificazione(idAzienda, day, giustificativi);
        if (!result.intervalli || result.hasErrorFuoriSede || result.hasErrorEccedente || result.hasErrorMancante)
            return 0;
        else {
            const coppiePrevisto: Coppia[] = [];
            for (const timbratura of result.intervalli) {
                coppiePrevisto.push(new Coppia(timbratura));
            }
            const previsto = new Calc();
            for (const coppia of coppiePrevisto)
                previsto.add(coppia);
            return previsto.getCount();
        }
    }
    const isFestivo = (day: PresenzeGiornataPlusRecord) => {
        if (day.festivo)
            return true;
        const dtGiornata = DateTime.fromISO(day.dtGiornata!);
        return !!elencoFestivita.find(dt => dt.equals(dtGiornata));
    }

    const inFiliale: boolean[] = xSetteGiorni.map(value => isInFiliale(days[value]));
    const inFilialeXPianificazione: boolean[] = xSetteGiorni.map(value => isInFilialeXPianificazione(days[value]));
    const outFiliale: boolean[] = xSetteGiorni.map(value => isOutFiliale(days[value]));
    return <div className={classNames(lavoratore ? styles.weekPaddingLavoratore : styles.weekPadding)}>
        {/*<table className={classNames(styles.week, 'border-collapse border-spacing-0')}>*/}
        <table className={classNames(styles.week)}>
            <thead>
            {/* ********************************** */}
            {/* *** Riepilogo ore contrattuali *** */}
            {showRiepiloghi &&
                <tr className={classNames('min-h-[18px]', alertAlto)}>
                    <th colSpan={hhWeeks.hhInizio === hhWeeks.hhFine ? 3 : 1}>
                        <TargetBox isWeek={true} tooltip={'Num. settimana'} enabled={targetWeek.length > 0}
                                   onDropTurno={turno => onDropTurno(turno, targetWeek)}
                                   onDropTurnoTool={tool => tool.name.localeCompare('pencil') === 0 ? onDropTurno(null, targetWeek) : onResetTurno(targetWeek)}
                                   onDropGiustificativo={giu => onDropGiustificativo(giu, targetWeek)}
                                   onDropFiliale={azienda => onDropFiliale(azienda, targetWeek)}
                        >
                            <span className={styles.valoreRiepilogo}>{DateTime.fromISO(week.dtInizioWeek!).weekNumber}</span>
                        </TargetBox>
                    </th>
                    <th colSpan={hhWeeks.hhInizio === hhWeeks.hhFine ? 4 : 6}><span className={styles.valoreRiepilogo}>{getLabelBaseHH(week, index)}</span></th>
                </tr>
            }
            {/* **************************** */}
            {/* *** Calendario (2 righe) *** */}
            {showCalendario && <>
                <tr>
                    {xSetteGiorni.map((value, index, array) => {
                        if (!days[value])
                            return <th key={index}>???</th>

                        return <th key={index}
                                   className={classNames('rounded-t-md',
                                       (lavoratore && days[value].dtGiornata === currentDtGiornata) && styles.hover,
                                       isCtrlPressed && styles.ctrl,
                                       getStyle(value),
                                       isFestivo(days[value]) && styles.domenica,
                                   )}>
                            {!inFiliale[value] &&
                                <span>{DateTime.fromISO(days[value].dtGiornata!).weekdayShort}</span>}
                            {inFiliale[value] &&
                                <Hover giornata={days[value]} setValue={setCurrentDtGiornata} onClickGiornata={onClickGiornata}>
                                    <div className="inline-flex">
                                        {(lavoratore && days[value].codTurnoPianificazione > 0) ?
                                            <IconAlarm className="my-auto ml-0.5 text-giornataPianificata" size={16}/> : <></>}
                                        <span>{DateTime.fromISO(days[value].dtGiornata!).weekdayShort}</span>
                                    </div>
                                </Hover>}
                        </th>
                    })}
                </tr>
                <tr className={classNames(styles.giorni)}>
                    {xSetteGiorni.map((value, index, array) => {
                        if (!days[value])
                            return <th key={index}>???</th>

                        return <th key={index}
                                   className={classNames((lavoratore && days[value].dtGiornata === currentDtGiornata) && styles.hover, isCtrlPressed && styles.ctrl, getStyle(value), isFestivo(days[value]) && styles.domenica)}>
                            {!inFiliale[value] &&
                                <span>{days[value].giorno}</span>}
                            {inFiliale[value] &&
                                <Hover giornata={days[value]} setValue={setCurrentDtGiornata} onClickGiornata={onClickGiornata}>
                                    <TargetBox enabled={days[value].totali !== null}
                                               onDropFiliale={ul => onDropFiliale(ul, days[value])}
                                               onDropTurno={turno => onDropTurno(turno, days[value])}
                                               onDropTurnoTool={tool => tool.name.localeCompare('pencil') === 0 ? onDropTurno(null, days[value]) : onResetTurno(days[value])}
                                               onDropGiustificativo={giu => onDropGiustificativo(giu, days[value])}
                                    >
                                        <div className="inline-flex">
                                            {outFiliale[value] && <IconCircleFilled className="my-auto ml-0.5 text-hhSuAltraSede" size={14}/>}
                                            <span>{days[value].giorno}</span>
                                        </div>

                                    </TargetBox>
                                </Hover>}
                        </th>
                    })}
                </tr>
            </>
            }
            </thead>
            <tbody>

            {/* **************************************** */}
            {/* *** Ore lavorate (giorno per giorno) *** */}
            {showOre && <tr className={styles.ore}>
                {xSetteGiorni.map((value, index, array) => {
                    if (!days[value])
                        return <td key={index}>???</td>

                    const hasGiuDiversi = PresenzeGiornataPlusRecord.hasGiuDiversi(days[value], giustificativi);
                    return <td key={index}
                               className={classNames(showCalendario ? '' : 'rounded-t-md', (lavoratore && days[value].dtGiornata === currentDtGiornata) && styles.hover, isCtrlPressed && styles.ctrl)}>
                        {!inFiliale[value] &&
                            <>
                                {inFilialeXPianificazione[value] &&
                                    <div className="inline-flex font-medium">
                                        {days[value].anomalia > 0 && <span className="text-anomalia font-semibold mr-0.5">!!</span>}
                                        <span>{asHHCC(getHHPianificate(days[value]))}</span>
                                        {hasGiuDiversi && <IconCircleFilled className="my-auto ml-0.5 text-hhAltreTipologie" size={14}/>}
                                        {!hasGiuDiversi && hasMancante(days[value].totali) &&
                                            <IconCircleFilled className="my-auto ml-0.5 text-hhMancanti" size={14}/>}
                                        {!hasGiuDiversi && hasEccedente(days[value].totali) &&
                                            <IconCircleFilled className="my-auto ml-0.5 text-hhEccedenti" size={14}/>}
                                    </div>}
                                {!inFilialeXPianificazione[value] && <span>-</span>}
                            </>
                        }
                        {inFiliale[value] &&
                            <Hover giornata={days[value]} setValue={setCurrentDtGiornata} onClickGiornata={onClickGiornata}>
                                <TargetBox enabled={days[value].totali !== null}
                                           onDropFiliale={ul => onDropFiliale(ul, days[value])}
                                           onDropTurno={turno => onDropTurno(turno, days[value])}
                                           onDropTurnoTool={tool => tool.name.localeCompare('pencil') === 0 ? onDropTurno(null, days[value]) : onResetTurno(days[value])}
                                           onDropGiustificativo={giu => onDropGiustificativo(giu, days[value])}
                                >
                                    <div className="inline-flex font-medium">
                                        {days[value].anomalia > 0 && <span className="text-anomalia font-semibold mr-0.5">!!</span>}
                                        <span>{formatLavorato(days[value].totali)}</span>
                                        {hasGiuDiversi && <IconCircleFilled className="my-auto ml-0.5 text-hhAltreTipologie" size={14}/>}
                                        {!hasGiuDiversi && hasMancante(days[value].totali) &&
                                            <IconCircleFilled className="my-auto ml-0.5 text-hhMancanti" size={14}/>}
                                        {!hasGiuDiversi && hasEccedente(days[value].totali) &&
                                            <IconCircleFilled className="my-auto ml-0.5 text-hhEccedenti" size={14}/>}
                                    </div>
                                </TargetBox>
                            </Hover>}
                    </td>
                })}
            </tr>}
            {/* ************************* */}
            {/* *** Descrizione turno *** */}
            {showTurno && <tr className={classNames(styles.turno, styles.ore)}>
                {xSetteGiorni.map((value, index, array) => {
                    if (!days[value])
                        return <td key={index}>???</td>

                    return <td key={index}
                               className={classNames(showOre ? 'rounded-b-md' : 'rounded-md',
                                   (lavoratore && days[value].dtGiornata === currentDtGiornata) && styles.hover,
                                   isCtrlPressed && styles.ctrl,
                               )}>
                        {!inFiliale[value] &&
                            <>
                                {inFilialeXPianificazione[value] && <BadgeTurnoByDay {...{day: days[value], turni, giustificativi}}/>}
                                {!inFilialeXPianificazione[value] && <span>-</span>}
                            </>
                        }
                        {inFiliale[value] &&
                            <Hover giornata={days[value]} setValue={setCurrentDtGiornata} onClickGiornata={onClickGiornata}>
                                <div className={classNames(alertUp, alertDwn, (showRiepiloghi ? styles.siRiepilogo : styles.noRiepilogo))}>
                                    <TargetBox enabled={days[value].totali !== null}
                                               className={classNames((alertUp || alertDwn) && 'my-0.5',
                                                   !showCalendario && outFiliale[value] && 'border-2 border-hhSuAltraSede border-dashed',
                                                   !showOre && hasMancante(days[value].totali) && 'bg-hhMancanti rounded',
                                                   !showOre && hasEccedente(days[value].totali) && 'bg-hhEccedenti rounded',
                                                   !showOre && hasMancante(days[value].totali) && hasEccedente(days[value].totali) ? styles.mancatiEccedenti : undefined,
                                                   styles.siRiepilogo,
                                               )}
                                               onDropFiliale={ul => onDropFiliale(ul, days[value])}
                                               onDropTurno={turno => onDropTurno(turno, days[value])}
                                               onDropTurnoTool={tool => tool.name.localeCompare('pencil') === 0 ? onDropTurno(null, days[value]) : onResetTurno(days[value])}
                                               onDropGiustificativo={giu => onDropGiustificativo(giu, days[value])}>
                                        <BadgeTurnoByDay {...{day: days[value], turni, giustificativi}}/>
                                    </TargetBox>
                                </div>
                            </Hover>}

                    </td>
                })}
            </tr>}
            </tbody>

            {
                showRiepiloghi && <tfoot>
                <tr>
                    <td colSpan={7} className={alertBasso}>
                        <div className="grid grid-cols-3 text-hh">
                            <TooltipEx tooltip={'Ore previste'}>
                                <div className={styles.valoreRiepilogo}><span className="inline-block align-middle">{asHHCC(RiepilogoOrePlus.getTotaleHPrev(week.totali!))}</span>
                                </div>
                            </TooltipEx>
                            <TooltipEx tooltip={'Ore lavorate ordinarie'}>
                                <div className={styles.valoreRiepilogo}>< span className="inline-block align-middle">{asHHCC(RiepilogoOrePlus.getTotaleHOrd(week.totali!))}</span>
                                </div>
                            </TooltipEx>
                            <TooltipEx tooltip={'Ore lavorate totali'}>
                                <BadgeHHCCLav hPrev={RiepilogoOrePlus.getTotaleHPrev(week.totali!)} hLav={RiepilogoOrePlus.getTotaleHLav(week.totali!)}/>
                            </TooltipEx>
                        </div>
                    </td>
                </tr>
                </tfoot>
            }

        </table>
    </div>
}

const Hover: FC<{
    children: React.ReactNode,
    onClickGiornata?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>, target: PresenzeGiornataPlusRecord) => void,
    giornata: PresenzeGiornataPlusRecord,
    setValue?: React.Dispatch<React.SetStateAction<FPNetDate>>,
}> = ({
          children,
          onClickGiornata = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, target: PresenzeGiornataPlusRecord) => {
          },
          giornata, setValue
      }) => {
    const {ref} = useHover2<HTMLDivElement>(giornata.dtGiornata, setValue)
    if (giornata.totali) { // Solo se lavoratore in forza!
        return <div ref={ref} onClick={(event) => onClickGiornata(event, giornata)}>{children}</div>;
    } else {
        return <div>{children}</div>;
    }
}

/**
 * Restituisce un array con le giornate della settimana utili all'impostazione massiva di un giustificativo/turno
 * La routine verifica la presenza del lavoratore in filiale (presenteDa e presenteA) e se in forza (day.totali!==null)
 * @param lavoratore
 * @param days
 */
function setupTargetWeek(lavoratore: LavoratorePresenzeRecord | null, days: PresenzeGiornataPlusRecord[]) {
    const week: PresenzeGiornataPlusRecord[] = [];
    if (!lavoratore || (!lavoratore.presenteDa && !lavoratore.presenteA)) return week;
    if (days) {
        for (const day of days) {
            if (day) {
                const presenteDa = lavoratore.presenteDa || day.dtGiornata;
                const presenteA = lavoratore.presenteA || day.dtGiornata;
                if (day && day.totali && isDateBetween(presenteDa!, presenteA!, day.dtGiornata!)) week.push(day);
            }
        }
    }
    return week;
}